<template>
  <v-app class="no_min_height">
    <v-card>
      <div class="container font_martel">
        <div class="d-md-block d-sm-block d-none">
          <img
            src="/front/images/login/zoopup-logo.png"
            alt="Description of Image"
            class="my-image"
          />
        </div>
        <br />
        <img
          src="/front/images/login/user_created.png"
          alt="User Created Image"
          class="published-image"
          height="372"
        />
        <h2 class="mt-4 head_title font-weight-black text_guide_color">
          User Created Successfully!!
        </h2>
        <p class="mt-4 subtitle">
          You have successfully created your
          <strong> {{ user_type }} account</strong>.<br />
          Ready to get started? Choose your path below:
        </p>

        <p class="info-text d-md-block d-sm-block d-none">
          <strong>Skipping profile</strong> completion
          <strong>may limit your visibility</strong> and reduce your chances of receiving project
          opportunities. It is <strong>recommended to complete your profile</strong> for better
          chances of success.
        </p>

        <div class="button-container">
          <button class="complete-button" @click="redirectToProfile">
            Complete Your Profile Now
          </button>
          <button class="skip-button" @click="redirectToDashboard">Skip Anyway</button>
        </div>
      </div>
      <span class="d-md-none d-sm-none d-block mt-n6">
        <p class="p-5 text-body-color font-10" style="margin-top: -60px">
          <strong>Skipping profile</strong> completion
          <strong>may limit your visibility</strong> and reduce your chances of receiving project
          opportunities. It is <strong>recommended to complete your profile</strong> for better
          chances of success.
        </p>
      </span>
      <!-- <div class="d-md-none d-sm-none d-block">
        <v-divider
          :thickness="1"
          color="grey"
          dark
          horizontal
          class="mx-5 my-4"
        ></v-divider>
      </div> -->
    </v-card>
    <div class="d-md-block d-sm-block d-none">
      <v-divider :thickness="1" color="grey" dark horizontal class="mx-5 my-4"></v-divider>

      <!-- Footer Links -->
      <div class="my-4 ml-5 footer text-start text-uppercase">
        <a class="footer_style" href="#">Terms of Use</a> •
        <a class="footer_style" href="#">Privacy Policy</a> •
        <a class="footer_style" href="#">Contact</a>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      user_type: localStorage.getItem('userType'),
    };
  },
  methods: {
    // Toggle password visibility
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    redirectToProfile() {
      const userTypeMapping = {
        Client: 'newclient',
        Freelancer: 'freelancer',
        Tutor: 'tutor',
        Student: 'student',
      };
      const path = userTypeMapping[this.user_type];
      window.location.href = `/${path}/profile`;
    },
    redirectToDashboard() {
      const userTypeMapping = {
        Client: 'newclient',
        Freelancer: 'freelancer',
        Tutor: 'tutor',
        Student: 'student',
      };
      const path = userTypeMapping[this.user_type];
      window.location.href = `/${path}`;
    },
  },
};
</script>

<style src="../../../../assets/css/clientPage.css"></style>

<style scoped>
@import '../../../../css/otp.css';
@import '../../../../css/loginnew.css';
@import url('https://fonts.googleapis.com/css2?family=Martel+Sans:wght@400;500;600;700;800;900&display=swap');

.published-image {
  display: block; /* Centers the image properly */
  max-width: 30%;
  height: auto;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

:deep(.v-application--wrap) {
  background-color: #ffffff !important;
}

.my-image {
  width: 100px;
  height: 65px;
}

.info-text {
  color: #666;
  font-size: 18px;
  margin-top: 30px;
  margin-bottom: 20px;
  text-align: center;
}

.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
}

.complete-button,
.skip-button {
  font-size: 16px;
  font-weight: 600;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 14px 40px;
  text-align: center;
  transition: all 0.3s ease-in-out;
}

.complete-button {
  background-color: #1569b2;
  color: #ffffff;
}

.skip-button {
  background-color: #ffffff;
  color: #1569b2;
  border: 1px solid #1569b2;
}

.skip-button:hover {
  background-color: #f0f0f0;
}

.complete-button:hover {
  background-color: #0b4e8b;
}

.text-body-color {
  color: #455065 !important;
}

.text_guide_color {
  color: #a0cc3c;
}

.footer {
  margin-bottom: -50px;
  margin-top: 30px;
  font-weight: 900;
  font-size: 12px;
}

.footer_style {
  color: #606060;
  margin: 0 5px;
  text-decoration: none;
}

.font_martel {
  font-family: 'Martel Sans' !important;
}

.container {
  text-align: center;
  padding: 2rem;
}

.head_title {
  font-size: 32px !important;
  font-family: 'Martel Sans' !important;
}

.subtitle {
  color: #666;
  margin-bottom: 2rem;
  font-size: 18px;
}

.v-card {
  width: 1000px;
  margin: 60px auto; /* Center the card */
}

@media (max-width: 768px) {
  .button-container {
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .complete-button,
  .skip-button {
    width: 80%;
    padding: 14px;
    max-width: 300px;
  }

  .head_title {
    font-size: 20px !important;
  }

  .subtitle {
    font-size: 14px !important;
  }

  .v-card {
    width: 100%;
    height: auto;
    margin: 0;
    padding: 20px;
  }

  .published-image {
    max-width: 80%;
  }
}

@media only screen and (min-width: 800px) and (max-width: 959px) {
  .complete-button {
    padding: 14px 50px;
  }

  .skip-button {
    padding: 14px 97px;
  }

  .button-container {
    margin-left: 25px;
  }
}

@media only screen and (min-width: 960px) and (max-width: 1260px) {
  .complete-button {
    padding: 14px 87px;
  }

  .skip-button {
    padding: 14px 140px;
  }

  .button-container {
    margin-left: 25px;
  }
}
</style>
